<template>
  <div class="container-fluid">
    <ul class="nav navbar-nav float-left mr-auto">
      <!-- <li>
        <input type="search" class="nav-item form-control" style="background-color:#ebf1f4; width: 400%;" placeholder="Search Here...">
      </li> -->
    </ul>
  </div>
</template>
<script>
  import ResetPasswordForm from "./profile/reset_password_form.vue";
  import EditProfileForm from "./profile/edit-profile.vue";
import CryptoJS from 'crypto-js';
  export default {
    components: {
       ResetPasswordForm,EditProfileForm
    },
    data: function () {
      return {
        role: "",
        fname: "",
        lname: "",
        id: "",
        
      };
    },
    created: function () {
      this.role = localStorage.getItem("role");
      this.fname = localStorage.getItem("f_name");
      this.lname = localStorage.getItem("l_name");
      this.id = localStorage.getItem("admin_id");
            
    },
    computed:{
      getUser: function(){  
        this.fname = localStorage.getItem("f_name");
        this.lname = localStorage.getItem("l_name");
      }
    },
    methods: {
      logout() {
        localStorage.removeItem("tab");
        localStorage.removeItem("role");
        localStorage.removeItem("admin_id");
        localStorage.removeItem("f_name");
        localStorage.removeItem("l_name");
        localStorage.removeItem("show_filter");
        localStorage.removeItem("software_filter");
        localStorage.removeItem("demo_filter");
        localStorage.removeItem("direction");
        localStorage.removeItem("column");
        // localStorage.removeItem('product');

        this.$auth.logout({
          makeRequest: true,
          data: {},
          success: function () { },
          error: function () { },
          redirect: "/login",
        });
      },
      passwordReset() {
        //  let pageNumber = this.page;
        this.$store.dispatch("modal/passwordReset", {
          action: "create",
          title: "Reset User Password",
          component: ResetPasswordForm,
        });
      },
      editProfile() {
        this.$store.dispatch("modal/editProfile", {
          action: "create",
          title: "Edit Profile",
          formData: {
            id: this.id,
            role: this.role,
          },
          component: EditProfileForm,
        });
      },
    },
  };
</script>
<style>
  #profile-menu:hover {
    background-color: #f4f8fa;
    margin: -2px -5px -0px -0px;
    padding: 2px 5px 0px 0px;
    border-radius: 20px;
  }

  .profile-dropdown-items {
    display: block;
    cursor: pointer;
    text-decoration: none;
    font-size: 13px;
    color: #575962;
    padding: 8px 14px;
  }

  .logout {
    display: block;
    cursor: pointer;
    text-decoration: none;
    font-size: 13px;
    color: #e2242d;
    padding: 8px 14px;
  }


</style>
<style scoped>
 @media (min-width: 320px) and (max-width:680px){
  #navbar_responsive{
    display: none !important;
  }
  .swicth_dashboard_btn{
    display: none;
  }
    /* .navbar-expand-lg  #navbar_responsive{
      display: block !important;
    } */
 }
</style>